import api from './api';

export async function getUserData() {
  const response = await api.get('/user');
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data;
}

export async function getPaymentHistory(userid) {
  const response = await api.get(`/getPurchaseHistory/${userid}`);
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data;
}
